import Api from '../api'
export default ({

  state: {
    analysisPurchaseProductWiseLists: [],
    analysisSalesProductWiseLists: [],
    analysisPurchaseSupplierWiseLists: [],
    analysisSalesCustomerWiseLists: [],
    analysisPurchaseMonthlySupplierWiseLists: [],
    analysisSalesMonthlyCustomerWiseLists: [],
    analysisPurchaseMonthlyItemWiseLists: [],
    analysisSalesMonthlyItemWiseLists: [],
    analysisPurchaseQuaterlyItemWiseLists: [],
    analysisSalesQuaterlyItemWiseLists: [],
    analysisPurchaseQuaterlySupplierWiseLists: [],
    analysisSalesQuaterlyCustomerWiseLists: [],
    analysisProfitLossItemWiseLists: [],
    profitAnalysisLists: [],
    salesPaidCollectionLists: []

  },
  mutations: {
    PURCAHSE_ANALYSIS_PRODUCT_WISE(state, analysisPurchaseProductWise) {
      state.analysisPurchaseProductWiseLists = analysisPurchaseProductWise
    },
    SALES_ANALYSIS_PRODUCT_WISE(state, analysisSalesProductWise) {
      state.analysisSalesProductWiseLists = analysisSalesProductWise
    },
    PURCAHSE_ANALYSIS_SUPPLIER_WISE(state, analysisPurchaseSupplierWise) {
      state.analysisPurchaseSupplierWiseLists = analysisPurchaseSupplierWise
    },
    SALES_ANALYSIS_CUSTOMER_WISE(state, analysisSalesCustomerWise) {
      state.analysisSalesCustomerWiseLists = analysisSalesCustomerWise
    },
    PURCAHSE_ANALYSIS_MONTHLY_SUPPLIER_WISE(state, analysisPurchaseMonthlySupplierWise) {
      state.analysisPurchaseMonthlySupplierWiseLists = analysisPurchaseMonthlySupplierWise
    },
    SALES_ANALYSIS_MONTHLY_CUSTOMER_WISE(state, analysisSalesMonthlyCustomerWise) {
      state.analysisSalesMonthlyCustomerWiseLists = analysisSalesMonthlyCustomerWise
    },
    PURCAHSE_ANALYSIS_MONTHLY_ITEM_WISE(state, analysisPurchaseMonthlyItemWise) {
      state.analysisPurchaseMonthlyItemWiseLists = analysisPurchaseMonthlyItemWise
    },
    SALES_ANALYSIS_MONTHLY_ITEM_WISE(state, analysisSalesMonthlyItemWise) {
      state.analysisSalesMonthlyItemWiseLists = analysisSalesMonthlyItemWise
    },
    PURCAHSE_ANALYSIS_QUATERLY_SUPPLIER_WISE(state, analysisPurchaseQuaterlySupplierWise) {
      state.analysisPurchaseQuaterlySupplierWiseLists = analysisPurchaseQuaterlySupplierWise
    },
    SALES_ANALYSIS_QUATERLY_CUSTOMER_WISE(state, analysisSalesQuaterlyCustomerWise) {
      state.analysisSalesQuaterlyCustomerWiseLists = analysisSalesQuaterlyCustomerWise
    },
    PURCAHSE_ANALYSIS_QUATERLY_ITEM_WISE(state, analysisPurchaseQuaterlyItemWise) {
      state.analysisPurchaseQuaterlyItemWiseLists = analysisPurchaseQuaterlyItemWise
    },
    SALES_ANALYSIS_QUATERLY_ITEM_WISE(state, analysisSalesQuaterlyItemWise) {
      state.analysisSalesQuaterlyItemWiseLists = analysisSalesQuaterlyItemWise
    },
    PROFIT_LOSS_ANALYSIS_ITEM_WISE(state, analysisProfitLossItemWise) {
      state.analysisProfitLossItemWiseLists = analysisProfitLossItemWise
    },
    PROFIT_LOSS_ANALYSIS_CUSTOMER_WISE(state, profitAnalysisList) {
      state.profitAnalysisLists = profitAnalysisList
    },
    SALES_PAID_COLLECTION(state, salesPaidCollectionList) {
      state.salesPaidCollectionLists = salesPaidCollectionList
    }
  },
  actions: {
    async loadPurchaseAnalysisWiseReport({ commit }, date) {
      let response = await Api.request('get', '/inventoryAnalysis/purchaseAnalysisProductWise/' + this.state.organisationid + '/' + date.fromDate + '/' + date.toDate)
      let responseValue = response.data.data
      commit('PURCAHSE_ANALYSIS_PRODUCT_WISE)', responseValue)
      return responseValue
    },
    async loadSalesAnalysisWiseReport({ commit }, date) {
      let response = await Api.request('get', '/inventoryAnalysis/salesAnalysisProductWise/' + this.state.organisationid + '/' + date.fromDate + '/' + date.toDate)
      let responseValue = response.data.data
      commit('SALES_ANALYSIS_PRODUCT_WISE)', responseValue)
      return responseValue
    },
    async loadSalesAnalysisCustomerWiseReport({ commit }, date) {
      let response = await Api.request('get', '/inventoryAnalysis/salesAnalysisCustomerWise/' + this.state.organisationid + '/' + date.fromDate + '/' + date.toDate)
      let responseValue = response.data.data
      commit('SALES_ANALYSIS_CUSTOMER_WISE)', responseValue)
      return responseValue
    },
    async loadPurchaseAnalysisSupplierWiseReport({ commit }, date) {
      let response = await Api.request('get', '/inventoryAnalysis/purchaseAnalysisSupplierWise/' + this.state.organisationid + '/' + date.fromDate + '/' + date.toDate)
      let responseValue = response.data.data
      commit('PURCAHSE_ANALYSIS_SUPPLIER_WISE)', responseValue)
      return responseValue
    },
    async loadPurchaseAnalysisMonthlySupplierWiseReport({ commit }, date) {
      let response = await Api.request('get', '/inventoryAnalysis/purchaseAnalysisMonthlySupplierWise/' + this.state.organisationid + '/' + this.state.fyId + '/' + date.warehouse + '')
      let responseValue = response.data.data
      commit('PURCAHSE_ANALYSIS_MONTHLY_SUPPLIER_WISE)', responseValue)
      return responseValue
    },
    async loadSalesAnalysisMonthlyCustomerWiseReport({ commit }, date) {
      let response = await Api.request('get', '/inventoryAnalysis/salesAnalysisMonthlyCustomerWise/' + this.state.organisationid + '/' + this.state.fyId + '/' + date.warehouse + '')
      let responseValue = response.data.data
      commit('SALES_ANALYSIS_MONTHLY_CUSTOMER_WISE)', responseValue)
      return responseValue
    },
    async loadSalesAnalysisMonthlyCustomerWiseFiscalYearReport({ commit }) {
      let response = await Api.request('get', '/inventoryAnalysis/reportpreviousAndCurrentSalesByfiscalyear/' + this.state.organisationid + '/' + this.state.fyId + '')
      let responseValue = response.data.data
      // commit('SALES_ANALYSIS_MONTHLY_CUSTOMER_WISE)', responseValue)
      return responseValue
    },
    async loadPurchaseAnalysisMonthlyItemWiseReport({ commit }, date) {
      let response = await Api.request('get', '/inventoryAnalysis/purchaseAnalysisMonthlyItemWise/' + this.state.organisationid + '/' + this.state.fyId + '/' + date.warehouse + '')
      let responseValue = response.data.data
      commit('PURCAHSE_ANALYSIS_MONTHLY_ITEM_WISE)', responseValue)
      return responseValue
    },
    async loadSalesAnalysisMonthlyItemWiseReport({ commit }, date) {
      let response = await Api.request('get', '/inventoryAnalysis/salesAnalysisMonthlyItemWise/' + this.state.organisationid + '/' + this.state.fyId + '/' + date.warehouse + '')
      let responseValue = response.data.data
      commit('SALES_ANALYSIS_MONTHLY_ITEM_WISE)', responseValue)
      return responseValue
    },
    async loadPurchaseAnalysisQuaterlyItemWiseReport({ commit }, date) {
      let response = await Api.request('get', '/inventoryAnalysis/purchaseAnalysisMonthlyItemWise/' + this.state.organisationid + '/' + this.state.fyId + '/' + date.warehouse + '')
      let responseValue = response.data.data
      commit('PURCAHSE_ANALYSIS_QUATERLY_ITEM_WISE)', responseValue)
      return responseValue
    },
    async loadSalesAnalysisQuaterlyItemWiseReport({ commit }, date) {
      let response = await Api.request('get', '/inventoryAnalysis/salesAnalysisMonthlyItemWise/' + this.state.organisationid + '/' + this.state.fyId + '/' + date.warehouse + '')
      let responseValue = response.data.data
      commit('SALES_ANALYSIS_QUATERLY_ITEM_WISE)', responseValue)
      return responseValue
    },
    async loadPurchaseAnalysisQuaterlySupplierWiseReport({ commit }, date) {
      let response = await Api.request('get', '/inventoryAnalysis/purchaseAnalysisMonthlySupplierWise/' + this.state.organisationid + '/' + this.state.fyId + '/' + date.warehouse + '')
      let responseValue = response.data.data
      commit('PURCAHSE_ANALYSIS_QUATERLY_SUPPLIER_WISE)', responseValue)
      return responseValue
    },
    async loadSalesAnalysisQuaterlyCustomerWiseReport({ commit }, date) {
      let response = await Api.request('get', '/inventoryAnalysis/salesAnalysisMonthlyCustomerWise/' + this.state.organisationid + '/' + this.state.fyId + '/' + date.warehouse + '')
      let responseValue = response.data.data
      commit('SALES_ANALYSIS_QUATERLY_CUSTOMER_WISE)', responseValue)
      return responseValue
    },
    async loadProfitLossAnalysisItemWiseReport({ commit }, date) {
      let response = await Api.request('get', '/inventoryAnalysis/profitLossAnalysisItemWise/' + this.state.organisationid + '/' + this.state.fyId + '/' + date.fromDate + '')
      let responseValue = response.data.data
      commit('PROFIT_LOSS_ANALYSIS_ITEM_WISE)', responseValue)
      return responseValue
    },
    async loadProfitLossAnalysisAccountItemWiseReport({ commit }, date) {
      let response = await Api.request('get', '/inventoryAnalysis/profitLossAnalysisItemAndPartyWise/' + this.state.organisationid + '/' + this.state.fyId + '/' + date.fromDate + '/' + date.toDate + '')
      let responseValue = response.data.data
      commit('PROFIT_LOSS_ANALYSIS_CUSTOMER_WISE)', responseValue)
      return responseValue
    },
    async loadSalesPaidCollectionReport({ commit }, reportType) {
      let response = await Api.request('get', '/inventoryAnalysis/salesCollectionMonthly/' + this.state.organisationid + '/' + this.state.fyId + '/' + reportType)
      let responseValue = response.data.data
      commit('SALES_PAID_COLLECTION)', responseValue)
      return responseValue
    },
    async loadItemWiseSalesMonthlyReport({ commit }, item) {
      let response = await Api.request('get', '/inventoryAnalysis/reportByItemWiseMonthlyPie/' + this.state.organisationid + '/' + this.state.fyId + '/' + item.id)
      if (response.data.status === 'SUCCESS') {
        return response.data.data[0]
      }
    },
    async loadMultiItemSalesMonthlyReport({ commit }, itemIds) {
      try {
        const response = await Api.request('post', `/inventoryAnalysis/reportByMultiItemMonthly/${this.state.organisationid}/${this.state.fyId}`, itemIds)
        return response.data.data
      } catch (error) {
        console.error('Failed to load multi-item report', error)
        throw error
      }
    },
    async loadMultiItemProfitMonthlyReport({ commit }, itemIds) {
      try {
        const response = await Api.request('post', `/inventoryAnalysis/monthlyProfitLossItemWise/${this.state.organisationid}/${this.state.fyId}`, itemIds)
        return response.data.data
      } catch (error) {
        console.error('Failed to load multi-item report', error)
        throw error
      }
    },
    async loadMonthlySalesPaidCollectionReport({ commit }, reportType) {
      try {
        const response = await Api.request('post', `/inventoryAnalysis/monthlySalesCashCollectionProfit/${this.state.organisationid}/${this.state.fyId}/${reportType}`)
        return response.data.data
      } catch (error) {
        console.error('Failed to load report', error)
        throw error
      }
    }
  },
  getters: {
  }
})



// WEBPACK FOOTER //
// ./src/store/analysisReport.js